import { gql } from 'graphql-tag';
import { ResourceMatchesStatus, ResourceRequestStatus } from '~/types';
import {
  specificResourceRequestWithAllocationsFragment,
  resourceMatchesFragment
} from '~/modules/resourcing/common/fragments';
import { mapToServiceRequest } from '../../util';
import { getSourceMetadata } from '../../hooks/useMarkToBeHiredResourceRequestWithHiringRequestedSubStatus';

export const SUBMIT_RESOURCE_REQUEST = gql`
  mutation MarkResourceRequestAsSubmitted(
    $input: MarkResourceRequestAsSubmittedInput!
    $resourceMatchesPage: Int = 1
    $resourceMatchesPageSize: Int = 1
    $isPsaPraaResourceMatchingEnabled: Boolean = false
  ) {
    markResourceRequestAsSubmitted2(input: $input) {
      resourceRequest {
        ...SpecificResourceRequestWithAllocation
        ...ResourceMatchesFragment
      }
    }
  }
  ${specificResourceRequestWithAllocationsFragment}
  ${resourceMatchesFragment}
`;

export const invokeMarkResourceRequestAsSubmitted = markResourceRequestAsSubmitted => ({
  request,
  chartSelectedTab,
  requestAccessLevel,
  cacheUpdateFunctions,
  isPtiEnabled,
  isPsaPraaResourceMatchingEnabled
}) =>
  markResourceRequestAsSubmitted(
    mapToServiceRequest({
      request,
      responseType: 'markResourceRequestAsSubmitted2',
      responseTypeName: 'MarkResourceRequestAsSubmittedResult',
      requestStatus: ResourceRequestStatus.Submitted,
      chartSelectedTab,
      requestAccessLevel,
      sourceMetadata: getSourceMetadata({
        isPtiEnabled,
        resourceRequest: request
      }),
      cacheUpdateFunctions,
      isPsaPraaResourceMatchingEnabled,
      resourceMatchesStatus: ResourceMatchesStatus.InProgress
    })
  );
